export default __webpack_public_path__ + "static/media/users.43a3c0a6.svg";